// Un'unica build serve tutti i clienti. Il brand (logo e favicon in
// public/brands/<id>/, nome, colore, URL pubblico) si sceglie con la variabile
// COMPANY del container (rdr | darf | aviomar), letta lato server all'avvio.
// COMPANY assente, vuota o sconosciuta → RDR, come la build storica.
export type Brand = {
  id: string
  name: string
  /** Ragione sociale completa, usata nelle firme delle email. Deve restare
   *  allineata a `legalName` in companies.ts del backend: le email partono da
   *  entrambi i lati e devono firmare con lo stesso nome. */
  legalName: string
  primaryColor: string
  url: string
}

const brandList: Brand[] = [
  { id: 'rdr', name: 'RDR', legalName: 'RDR SPA Società Benefit', primaryColor: '#1DA1F2', url: 'https://albo.rdr.it' },
  { id: 'darf', name: 'DARF', legalName: 'DARF S.r.l. Società Benefit', primaryColor: '#102D69', url: 'https://albo.darf.it' },
  { id: 'aviomar', name: 'RDR Officine Aviomar', legalName: 'Officine RDR Aviomar S.r.l.', primaryColor: '#36A9E1', url: 'https://albo.officinerdraviomar.it' }
]

export const getBrand = (): Brand =>
  brandList.find(b => b.id === process.env.COMPANY?.trim().toLowerCase()) ?? brandList[0]
